import request from "@/utils/request";

export function publishGoodsSource(data) {
  return request({
    url: "/api/mts-api/clue/publish",
    method: "post",
    data: data,
  });
}

export function getGoodsSource(id) {
  return request({
    url: "/api/mts-api/clue/" + id,
    method: "get",
  });
}

export function saveGoodsSourceDetail(data) {
  return request({
    url: "/api/mts-api/clue/saveDetail",
    method: "post",
    data: data,
  });
}

export function importClue(data) {
  return request({
    url: "/api/mts-api/clue/import",
    timeout: Number(process.env.VUE_APP_CLUE_IMPORT_TIMEOUT) || 120000,
    method: "post",
    data: data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export function getClueDetail(id) {
  return request({
    url: "/api/mts-api/clue/clueDetail?clueId=" + id,
    method: "get",
  });
}

export function reviewInformation(data) {
  return request({ url: "/api/mts-api/clue/reviewInformation", method: "post", data });
}

export function auditClue(data) {
  return request({
    url: "/api/mts-api/clue/batchAudit",
    method: "post",
    data: data,
  });
}

export function deleteClue(data) {
  return request({
    url: "/api/mts-api/clue/deleteClue",
    method: "post",
    data: data,
  });
}
